(function () {
    'use strict';

    if (typeof Lenis === 'undefined' || typeof gsap === 'undefined') return;

    window.apollonLenis = new Lenis({
        duration: 1.2,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
    });

    // Lenis driven by GSAP ticker
    window.apollonLenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add(function (time) {
        window.apollonLenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
})();
